import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';
import {getUUID} from '../../../../utils/getUUID';
import CustomButton from './custom-button';

export default class ButtonCell extends BaseCell {
  render() {

    const {isBot, time, text, buttons, buttonLayoutType} = this.props;

    return (
      <div className={this.messageClass(isBot)}>
        <div className={'cu-ui-message-block'}>
          <div className={'cu-ui-message-avatar'}></div>
          <div className={'cu-ui-message-content cu-ui-message-buttons'}>
            <p>
              {text}
            </p>
            { this.renderButton(buttons, buttonLayoutType) }
          </div>
        </div>
        <div className={'cu-ui-message-time'}>
          {time}
        </div>
      </div>
    )
  }

  renderButton(buttons, buttonLayoutType) {
    switch (buttonLayoutType) {
      case "block":
        return _.map(buttons, (b) => {
          return <CustomButton button={b} buttonType={'wide'} key={getUUID()}/>;
        });
      case "flex":
        return (
          <div className={'cu-ui-button-group cu-ui-block'}>
            {
              _.map(buttons, (b) => {
                return <CustomButton button={b} buttonType={'block'} key={getUUID()}/>;
              })
            }
          </div>
        )
    }
  }
}

ButtonCell.propTypes = {
  isBot: PropTypes.bool,
  time: PropTypes.string,
  text: PropTypes.string,
  buttonLayoutType: PropTypes.string,
  buttons: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/chat-body/chat-cells/button-cell/index.jsx